import { Injectable } from '@angular/core';
import { AutoCompleteMappedItem } from '../../common/components/auto-complete/auto-complete.component';
import { HttpClient } from '@angular/common/http';
import { PlannerEndpoints } from '../constants/planner-endpoints.const';

@Injectable({
    providedIn: 'root'
})
export class MarketAdvertiserContextService {

    constructor(private http: HttpClient) { }

    public autoCompleteResponseMapper(response: any, offset: number, limit: number) {
        // response will be the form of [{'id' : 'name'}] : [{'1' : 'turn'}]
        let items: AutoCompleteMappedItem[] = [];
        let hasMore = false;
        if (response) {
            hasMore = response.length >= limit;
            items = response.map((item) => {
                let id = Object.keys(item)[0];
                return {
                    label: item[id] + ' (' + id + ')',
                    value: id
                }
            });
        }
        return {
            results: items,
            hasMore: hasMore
        }
    }

    // marketId is required when endpoint is for advertiser
    public getFullList(level: 'MARKET' | 'ADVERTISER', marketId?: string | number): Promise<any> {
        if (level === 'MARKET') {
            // request cache service should be handled by not have get request if it is second call
            return this.http.get(PlannerEndpoints.dspMarkets).toPromise()
        } else if (level === 'ADVERTISER') {
            if (marketId) {
                let endpoint = PlannerEndpoints.dspAdvertisers + '?marketId=' + marketId;
                // request cache service should be handled by not have get request if it is second call
                return this.http.get(endpoint).toPromise();
            } else {
                return new Promise((resolve, reject) => {
                    reject('Market Id can not be empty');
                });
            }
        }
    }

    public getById(id: number | string, level: 'MARKET' | 'ADVERTISER', marketId?: string | number): Promise<any> {
        return this.getFullList(level, marketId).then((data: any[]) => {
            let results = []
            let object = data.find((value) => {
                return Object.keys(value)[0] == id;
            });
            if (object) {
                results.push(object);
            }
            return results;
        });
    }

    public autoCompletePromiseSetUp(level: 'MARKET' | 'ADVERTISER', marketId?: string | number) {
        return (params: any): Promise<any> => {
            return this.getFullList(level, marketId).then((data: any[]) => {
                return this.applySearchAndPagination(data, params);
            });
        };
    }

    private applySearchAndPagination(data: any[], params: any): any[] {
        // create new reference
        let results = [...data], searchString = params.searchString, limit = params.limit, offset = params.offset;
        if (results && results.length > 0) {
            if (searchString != null && searchString.length > 0) {
                searchString = searchString.trim().toLowerCase();
                results = results.filter((value: any) => {
                    let id: string = Object.keys(value)[0];
                    return id === searchString || value[id].toLowerCase().includes(searchString);
                });
            }
            let limitNum = +limit, offsetNum = +offset;
            if (results.length > 0 && limitNum > 0 && offsetNum >= 0) {
                if (results.length > offsetNum) {
                    if (results.length > (offsetNum + limitNum)) {
                        results = results.slice(offsetNum, offsetNum + limitNum);
                    } else {
                        results = results.slice(offsetNum);
                    }
                } else {
                    results.length = 0;
                }
            }
        }
        return results;
    }
}